import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {
  SUPERUSER_APPROVAL,
  APPLICATION_ROLES,
} from '../../../constants';
import COLORS from '../../../../constants/colors';
import { Chip } from '@material-ui/core';
import { getStatusChipProps } from 'components/product/ProductCard/ProductStatusChip';

export const getMenuItemStyle = adminStatus => {
  const approved = { color: COLORS.mainGreen, fontWeight: 'bolder' };
  const awaiting = { color: COLORS.mainOrange, fontWeight: 'bolder' };
  const notApproved = { color: COLORS.mainRed, fontWeight: 'bolder' };

  switch (adminStatus) {
    case SUPERUSER_APPROVAL.ADMIN_APPROVED:
      return approved;
    case SUPERUSER_APPROVAL.ADMIN_DISAPPROVED:
      return notApproved;
    default:
      return awaiting;
  }
};

export const Review = ({ state, setState, userRole, isCreatingNew, product, isAiChangedState }) => {
  const isSuperuser = userRole === APPLICATION_ROLES.SUPERUSER;
  const isProducer = userRole === APPLICATION_ROLES.PRODUCER || APPLICATION_ROLES.STORE;
 
  const handleChange = event => {
    // Enforce float if descriptive_size_amount
    const stateName = event.target.name;
    let stateValue = event.target.value;
    console.log(`NAME: ${stateName} - VALUE: ${stateValue}`);
    setState({ ...state, [stateName]: stateValue });
  };
  // The chip shows the saved status, so it reads the saved product, not the form state.
  const chipProps = product ? getStatusChipProps(product, { isSuperuser, isProducer }) : {};
  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
        {isSuperuser && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div style={{ color: 'rgb(158, 158, 158)', fontWeight: 600 }}>
              Granskningsstatus
            </div>
            <FormControl size='small'>
              <Select
                labelId="adminStatusLabel"
                id="adminStatus"
                name="adminStatus"
                value={state.adminStatus}
                style={{ ...getMenuItemStyle(state.adminStatus), width: 200 }}
                onChange={handleChange}
                variant="outlined"
              >
                <MenuItem
                  style={getMenuItemStyle(SUPERUSER_APPROVAL.ADMIN_APPROVED)}
                  value={SUPERUSER_APPROVAL.ADMIN_APPROVED}
                >
                  Approved Review
                </MenuItem>
                <MenuItem
                  style={getMenuItemStyle(SUPERUSER_APPROVAL.AWAITING_APPROVAL)}
                  value={SUPERUSER_APPROVAL.AWAITING_APPROVAL}
                >
                  Under Review
                </MenuItem>
                <MenuItem
                  style={getMenuItemStyle(SUPERUSER_APPROVAL.ADMIN_DISAPPROVED)}
                  value={SUPERUSER_APPROVAL.ADMIN_DISAPPROVED}
                >
                  Failed Review
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ color: 'rgb(158, 158, 158)', fontWeight: 600 }}>
            Sparad status
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
            <Chip
              label={product ? chipProps?.label : 'Inte sparad'}
              style={{
                fontWeight: 600,
                background: chipProps?.bgColor,
                color: chipProps?.textColor,
              }}
            />
            {!!product?.isDraft && <span>Inte skickad för granskning</span>}
          </div>
        </div>
      </div>

      {!isSuperuser && !!isAiChangedState && (
        <h5 style={{ margin: 3, textAlign: 'center' }}>
          Genom att skapa eller uppdatera produkten intygar du att du har kontrollerat att den uppladdade produktinformationen är korrekt och överensstämmer med din bästa bedömning.
        </h5>
      )}
    </>
  );
};

export default Review;
